var React = require('react');

function AsanaPlow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M18,23c0,0,4.344,0,6,0s3,1.343,3,3s-1.344,3-3,3\n\tS0,29,0,29 M37,27c-9-8.5-18-10.583-18-10.583S17,18.5,17,22c0,4,2,7,2,7 M37,30v-6.667C34.074,19.616,25,9,19,9\n\tC14.25,9,9,14.357,9,20.395C9,22.139,9.171,23.455,9.653,25H14"}));
}

AsanaPlow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaPlow;

AsanaPlow.default = AsanaPlow;
